import React, { useState } from "react";
import { Container } from "lucide-react";
import GestionaleShell from "./GestionaleShell";
import GestCrudTable from "./GestCrudTable";

const FIELDS = [
  { key: "code", label: "Codice container", type: "text", required: true },
  { key: "type", label: "Tipologia", type: "select", options: [
    { value: "20RF", label: "20' Reefer" }, { value: "40RF", label: "40' Reefer HC" },
    { value: "20DV", label: "20' Dry" }, { value: "40HC", label: "40' HC Dry" },
  ], defaultValue: "20RF" },
  { key: "vessel", label: "Vessel", type: "text" },
  { key: "pol", label: "POL (Imbarco)", type: "text", defaultValue: "Genova" },
  { key: "pod", label: "POD (Sbarco)", type: "text", defaultValue: "Santos" },
  { key: "etd", label: "ETD", type: "date", hideInTable: true },
  { key: "eta", label: "ETA", type: "date" },
  { key: "total_cbm", label: "CBM totale", type: "number", step: "0.1", hideInTable: true },
  { key: "total_pallets", label: "Pallet totali", type: "number", step: "1" },
  { key: "status", label: "Stato", type: "select", statusTone: true, options: [
    { value: "planning", label: "Planning", tone: "stone" },
    { value: "booked", label: "Bookato", tone: "blue" },
    { value: "loaded", label: "Caricato", tone: "gold" },
    { value: "in_transit", label: "In transito", tone: "amber" },
    { value: "arrived", label: "Arrivato", tone: "emerald" },
    { value: "cleared", label: "Sdoganato", tone: "emerald" },
  ], defaultValue: "planning" },
  { key: "notes", label: "Note", type: "textarea", hideInTable: true },
];

export default function ContainersPage() {
  const [data, setData] = useState({ total: 0, items: [] });
  const inTransit = (data.items || []).filter(i => ["loaded", "in_transit"].includes(i.status)).length;

  return (
    <GestionaleShell
      icon={Container}
      code="04"
      title="Container & Shipping"
      subtitle="Pianificazione consolidamento multi-fornitore. Vessel tracking, ETD/ETA, CBM e pallet."
      kpiBlocks={[
        { value: data.total || 0, label: "Container" },
        { value: inTransit, label: "In transito" },
      ]}
    >
      <GestCrudTable
        endpoint="/gestionale/containers"
        fields={FIELDS}
        itemLabel="container"
        emptyHint="Apri la pianificazione del primo container reefer Italia → Brasile."
        testIdPrefix="containers"
        onItemsLoaded={(d) => setData(d)}
      />
    </GestionaleShell>
  );
}
